import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const COLS = [["type", "Tipo di furgone", "text"], ["price", "Prezzo €/giorno", "number"], ["cost", "Costo €/giorno (interno)", "number"], ["consumption", "Consumo km/l", "number"]];

export const VanTypesEditor = ({ value, onChange, fuel, onFuel }) => {
  const set = (i, k, v) => onChange(value.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <section className="bg-slate-900 border border-slate-800 rounded-lg p-5 space-y-3" data-testid="settings-vans-section">
      <h2 className="text-base md:text-lg font-semibold">Furgoni e trasporto</h2>
      <p className="text-xs text-slate-500">I km si calcolano su strada dall'indirizzo della sede indicato sopra.</p>
      <div className="hidden sm:grid grid-cols-[2fr_1fr_1fr_1fr_40px] gap-2">{COLS.map(([k, l]) => <Label key={k} className="micro-label">{l}</Label>)}</div>
      {value.map((v, i) => (
        <div key={i} className="grid grid-cols-2 sm:grid-cols-[2fr_1fr_1fr_1fr_40px] gap-2" data-testid={`settings-van-row-${i}`}>
          {COLS.map(([k, l, t]) => (
            <Input key={k} type={t} min={0} step="0.01" aria-label={l} placeholder={l} value={v[k] ?? ""} className={t === "number" ? "font-mono" : "col-span-2 sm:col-span-1"}
              onChange={(e) => set(i, k, t === "number" ? e.target.value : e.target.value)} data-testid={`settings-van-${k}-${i}`} />
          ))}
          <Button variant="ghost" size="icon" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`settings-van-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <div className="flex flex-wrap items-end justify-between gap-3">
        <Button variant="outline" onClick={() => onChange([...value, { type: "", price: "", cost: "", consumption: "" }])} data-testid="settings-van-add-btn"><Plus className="h-4 w-4 mr-1" />Tipo di furgone</Button>
        <div className="space-y-1.5"><Label className="micro-label">Prezzo gasolio predefinito €/l</Label>
          <Input type="number" min={0} step="0.001" value={fuel ?? 0} onChange={(e) => onFuel(e.target.value)} className="font-mono w-36" data-testid="settings-default-fuel-input" /></div>
      </div>
    </section>
  );
};
